const QUESTIONS = [
  {
    id: "q1",
    type: "text",
    prompt:
      "if you could master one weirdly specific skill overnight, what is it?",
    placeholder: "be honest, be unhinged",
    myAnswer:
      "falling asleep immediately whenever i want. i stay up way too late watching tiktok and reels...",
  },
  {
    id: "q2",
    type: "long",
    prompt:
      "what's something people misunderstand about you that you secretly wish they got right?",
    placeholder: "i'll go after you do, promise",
    myAnswer:
      "i'm autistic. i have no object permanance so i WILL forget to reply but it doesn't mean i don't care or do it on purpose...",
  },
  {
    id: "q3",
    type: "choice",
    prompt: "the ideal saturday morning is:",
    options: [
      "still asleep, please don't",
      "waking up early to see the sunrise on the beach",
      "going to sleep at 6am after gaming all night",
      "in bed with someone who makes me laugh",
    ],
    myAnswer: "going to sleep at 6am after gaming all night",
  },
  {
    id: "song1",
    type: "song",
    prompt:
      "song round — 1 of 5: a song that you would play at my hamster's funeral so i laugh instead of cry.",
    placeholder: "spotify or youtube link…",
    myAnswer: "https://open.spotify.com/track/4cOdK2wGLETKBW3PvgPWqT",
  },
  {
    id: "song2",
    type: "song",
    prompt:
      "song round — 2 of 5: a song that goes hard but you're embarrassed to admit you know every word.",
    placeholder: "no judgment. (i'm judging a little.)",
    myAnswer:
      "https://open.spotify.com/track/45hOioMDJktr86iKDHC8gr?si=1575df50555b4d4a",
  },
  {
    id: "song3",
    type: "song",
    prompt:
      "song round — 3 of 5: a song you'd put on right after winning a fistfight in a waffle house parking lot.",
    placeholder: "the fight was over honor. probably.",
    myAnswer:
      "https://open.spotify.com/track/7CpbhqKUedOIrcvc94p60Y?si=c29b43c994e94977",
  },
  {
    id: "song4",
    type: "song",
    prompt:
      "song round — 4 of 5: a song that immediately makes you feel 17 again.",
    placeholder: "the embarrassing kind of nostalgia",
    myAnswer:
      "https://open.spotify.com/track/3DamFFqW32WihKkTVlwTYQ?si=252f997a55274761",
  },
  {
    id: "song5",
    type: "song",
    prompt:
      "song round — 5 of 5: a song you'd play on a slow drive together with no destination.",
    placeholder: "stakes are high. choose wisely.",
    myAnswer:
      "https://open.spotify.com/track/7K3Lc3TfSR14aTOjIH7TUj?si=34c57ff0845b44bd",
  },
  {
    id: "q9",
    type: "text",
    prompt:
      "tell me one tiny thing about you nobody on your social medias would know.",
    placeholder: "save the rest for sunday",
    myAnswer:
      "i am scared of the ocean. i've had nightmares about drowning or getting eaten by a giant squid since I was little.",
  },
];

function parseMediaUrl(url) {
  if (!url) return null;
  const trimmed = url.trim();
  const sp = trimmed.match(
    /open\.spotify\.com\/(?:intl-[a-z]+\/)?(track|album|playlist|episode)\/([a-zA-Z0-9]+)/
  );
  if (sp) return { type: "spotify", kind: sp[1], id: sp[2] };
  const yt =
    trimmed.match(/youtu\.be\/([a-zA-Z0-9_-]{6,})/) ||
    trimmed.match(/youtube\.com\/watch\?v=([a-zA-Z0-9_-]{6,})/) ||
    trimmed.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]{6,})/);
  if (yt) return { type: "youtube", id: yt[1] };
  return null;
}

function MediaEmbed({ url, compact }) {
  const parsed = parseMediaUrl(url);
  if (!parsed) {
    return url ? (
      <p className="hint">
        hmm, that link doesn't look like a spotify or youtube one. paste the
        full url and i'll show it here.
      </p>
    ) : null;
  }
  const h = compact ? 80 : parsed.type === "youtube" ? 240 : 152;
  if (parsed.type === "spotify") {
    return (
      <iframe
        title="spotify embed"
        src={`https://open.spotify.com/embed/${parsed.kind}/${parsed.id}`}
        width="100%"
        height={h}
        frameBorder="0"
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
        style={{ borderRadius: 8, marginTop: 12 }}
      />
    );
  }
  return (
    <iframe
      title="youtube embed"
      src={`https://www.youtube.com/embed/${parsed.id}`}
      width="100%"
      height={h}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      loading="lazy"
      style={{ borderRadius: 8, marginTop: 12 }}
    />
  );
}

function QuestionBlock({ q, index, total, value, isSubmitted, onChange, onSubmit, onNext, isLast }) {
  const hasAnswer =
    q.type === "choice" ? !!value : (value || "").toString().trim().length > 0;
  const canSubmit = q.type === "song" ? !!parseMediaUrl(value) : hasAnswer;

  return (
    <div className="q-block scene-mount">
      <div className="q-counter">
        <span>{String(index + 1).padStart(2, "0")}</span>
        <span className="q-counter-sep">/</span>
        <span className="q-counter-total">{String(total).padStart(2, "0")}</span>
      </div>

      <h2 className="q-prompt">{q.prompt}</h2>

      <div className="q-input">
        {q.type === "text" && (
          <input
            type="text"
            value={value}
            placeholder={q.placeholder || ""}
            disabled={isSubmitted}
            onChange={(e) => onChange(e.target.value)}
          />
        )}

        {q.type === "long" && (
          <textarea
            value={value}
            placeholder={q.placeholder || ""}
            rows={4}
            disabled={isSubmitted}
            onChange={(e) => onChange(e.target.value)}
          />
        )}

        {q.type === "song" && (
          <>
            <input
              type="text"
              value={value}
              placeholder={q.placeholder || ""}
              disabled={isSubmitted}
              onChange={(e) => onChange(e.target.value)}
            />
            <MediaEmbed url={value} />
          </>
        )}

        {q.type === "choice" && (
          <div className="choice-list">
            {q.options.map((opt) => {
              const selected = value === opt;
              return (
                <button
                  key={opt}
                  type="button"
                  className={`choice-btn ${selected ? "is-selected" : ""}`}
                  disabled={isSubmitted}
                  onClick={() => onChange(opt)}
                >
                  {opt}
                </button>
              );
            })}
          </div>
        )}
      </div>

      {!isSubmitted ? (
        <div className="q-submit">
          <button
            className="btn"
            onClick={onSubmit}
            disabled={!canSubmit}
            style={{
              opacity: canSubmit ? 1 : 0.4,
              cursor: canSubmit ? "pointer" : "not-allowed",
            }}
          >
            <span className="btn-text">enter</span>
          </button>
        </div>
      ) : (
        <>
          <div className="q-reveal">
            <p className="q-reveal-label">↓ here's how i answered</p>
            {q.type === "song" ? (
              <MediaEmbed url={q.myAnswer} compact />
            ) : (
              <p className="q-reveal-body">{q.myAnswer}</p>
            )}
          </div>
          <div className="scene-nav">
            <button className="btn" onClick={onNext}>
              <span className="btn-text">{isLast ? "continue →" : "next →"}</span>
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default function Questionnaire({ session, update, goTo }) {
  const answers = session.answers || {};
  const submitted = session.submitted || {};
  const qIndex = Math.min(session.qIndex || 0, QUESTIONS.length - 1);
  const q = QUESTIONS[qIndex];
  const isLast = qIndex === QUESTIONS.length - 1;

  const saveAnswer = (newValue) => {
    update({ answers: { ...answers, [q.id]: newValue } });
  };
  const submit = () => {
    update({ submitted: { ...submitted, [q.id]: true } });
  };
  const next = () => {
    if (isLast) {
      goTo("herQuestions");
    } else {
      update({ qIndex: qIndex + 1 });
    }
  };

  return (
    <section className="section questionnaire-section">
      <QuestionBlock
        key={q.id}
        q={q}
        index={qIndex}
        total={QUESTIONS.length}
        value={answers[q.id] ?? (q.type === "choice" ? null : "")}
        isSubmitted={!!submitted[q.id]}
        onChange={saveAnswer}
        onSubmit={submit}
        onNext={next}
        isLast={isLast}
      />
    </section>
  );
}
